import {FillInTheBlankQuestion} from './FillInTheBlank/FillInTheBlankQuestion.react';
import {FreeEntryQuestion} from './FreeEntry/FreeEntryQuestion.react';
import {FreeResponseQuestion} from './FreeResponse/FreeResponseQuestion.react';
import GraphingQuestion from './Graphing/GraphingQuestion.react';
import {MultipleChoiceQuestion} from './MultipleChoice/MultipleChoiceQuestion.react';
import {PassageCorrectionQuestion} from './PassageCorrection/PassageCorrectionQuestion.react';
import {SnippetSelectionQuestion} from './SnippetSelection/SnippetSelectionQuestion.react';
import {TextHighlightQuestion} from './TextHighlight/TextHighlightQuestion.react';
import {TwoWayQuestion} from './TwoWay/TwoWayQuestion.react';
import {FillInTheBlankQuestionBank as ItemBankQuestion} from './FitbItemBank';
import {OrderingQuestion} from './Ordering';
/**
 * @todo: Build this out for all question types...
 */

const questionTypes = {
  'multiple-choice': MultipleChoiceQuestion,
  'snippet-selection': SnippetSelectionQuestion,
  'free-entry': FreeEntryQuestion,
  'free-response': FreeResponseQuestion,
  'fill-in-the-blank': FillInTheBlankQuestion,
  // along with QuestionModel.v3.js
  'item-bank': ItemBankQuestion,
  ordering: OrderingQuestion,
  'two-way': TwoWayQuestion,
  'passage-correction': PassageCorrectionQuestion,
  'text-highlight': TextHighlightQuestion,
  'graph-contains': GraphingQuestion
};

export function getRendererForQuestion(question) {
  return questionTypes[question.getQuestionType()];
}
